module.exports = __webpack_public_path__ + "img/forgiveness-watch-btn.f2935942.png";